import JcBasicProfile from './basic-profile'

JcBasicProfile.install = Vue => {
  Vue.component(JcBasicProfile.name, JcBasicProfile)
}

export { JcBasicProfile }



// WEBPACK FOOTER //
// ./src/components/profile/index.js